import styled, { css } from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { signout } from '~/components/authentication/ducks/index.js';
import Icon, { ICON_DOCUMENT_SEARCH_LINE } from '~/components/icon/index.js';
import { HeadWrapper, MainTitle /* SubTitle */ } from '../misc/section-head.js';
import TextWrapper from './text-wrapper.js';
import breakpoint from '../../utils/style-utils';
import IconArrowLeftButton from '../misc/icon-arrow-left-button.js';
import SidebarHeader from '../header/sidebar-header.js';
import Title from '../layout/header/title.js';
import { Smaller, Bigger } from '../layout/mediaquery.js';
import useTranslations from '~/components/translation/use-translations.ts';
import Loading from '~/components/misc/loading.js';
import useUIContext from '~/ui/use-ui-context';
import { useTheme } from '~/components/theme/theme-context';
import useRouterCallbacks from '~/hooks/use-router-callbacks';

const TCWrapper = styled.div`
	--buttonWrapperBg: rgba(var(--base-11), 1);
	${props =>
		props.isInSidebar
			? css`
					padding: 0;
				`
			: css`
					${breakpoint.lg`
					padding-top: var(--subHeaderHeight);
					`};
				`};
`;

const TEXT_KEYS = ['LANDING_PAGE_BONUS_TC_HEADER'];

const TermsConditionsBonus = ({ className, returnTo, onCloseCB, paginate, goToPrevious }) => {
	const dispatch = useDispatch();
	const { shouldShowComplianceMessage, registrationToken } = useSelector(state => state.authentication);
	const bonusTerms = useSelector(state => state.brand.bonusTerms);
	const screenMedium = useSelector(state => state.browser.lessThan.medium);

	const { translations: t, isLoadingTranslations } = useTranslations(TEXT_KEYS);
	const { withinSidebar } = useUIContext();
	const { Logo } = useTheme();
	const { pushBack } = useRouterCallbacks();

	const onClose = () => {
		if (returnTo) {
			paginate(returnTo);
		} else if (registrationToken) {
			goToPrevious();
		} else if (shouldShowComplianceMessage) {
			dispatch(signout({}));
		} else if (onCloseCB) {
			onCloseCB();
		} else if (window.location && window.location.pathname) {
			pushBack();
		} else {
			pushBack();
		}
	};

	if (isLoadingTranslations) {
		return <Loading />;
	}

	return (
		<TCWrapper className={`static-text terms-conditions ${className}`} isInSidebar={withinSidebar}>
			{withinSidebar && (
				<SidebarHeader
					transparent={!screenMedium}
					Icon={
						<IconArrowLeftButton
							className="page-head__back"
							onClick={onClose}
							data-at="close-general-global-overlay"
						/>
					}
				>
					<Smaller>
						<div className="page-head__title svg-logo--dark" data-at="title-terms-conditions-page">
							<Logo />
						</div>
					</Smaller>

					<Bigger>
						<Title
							automationClass="automation-test-title-terms-conditions-page"
							dataAt="title-terms-conditions-page"
						>
							{t.LANDING_PAGE_BONUS_TC_HEADER}
						</Title>
					</Bigger>

					<div className="page-head__right-side" />
				</SidebarHeader>
			)}
			<div className="u-scroll-content-wrapper u-pl1 u-pr1 u-pb1">
				<HeadWrapper className="section-head__head-wrapper">
					<Icon type={ICON_DOCUMENT_SEARCH_LINE} />
					<MainTitle dataAt="section-main-title-general-global-overlay">
						{t.LANDING_PAGE_BONUS_TC_HEADER}
					</MainTitle>
				</HeadWrapper>
				<TextWrapper
					dangerouslySetInnerHTML={{
						__html: bonusTerms
					}}
				/>
			</div>
		</TCWrapper>
	);
};

export default TermsConditionsBonus;
